import React, { Component } from "react";
import { connect } from "react-redux";
import { SecondarySalesEndStockChar } from "./SecondarySales_EndStockChar";
import { Loader } from "../../components/loader";

import Button from "@material-ui/core/Button";

import DownloadIcon from "../../assets/images/downloadIcon.svg";
import Downloading from "../../assets/gifs/Downloading.gif";
import CategoryMiddleware from "../../store/middleware/categoryMiddleware";
import BrandsMiddleware from "../../store/middleware/brandsMiddleware";
import SkusMiddleware from "../../store/middleware/skusMiddleware";
import RegionsMiddleware from "../../store/middleware/regionMiddleware";
import SecondaryDashboardMiddleware from "../../store/middleware/secondaryDashboardMiddlware";
import DownloadSecondaryXlxMiddleware from "../../store/middleware/downloadSecondaryXlxMiddleware";
import ChannelSaleMiddleware from "../../store/middleware/channelSaleMiddleware";
import RegionsGrowthMiddleWare from "../../store/middleware/regionsGrowthMiddleware";
import ChannelMiddleware from "../../store/middleware/channelMiddleware";
import SecondarySale_EndStock_Middleware from "../../store/middleware/secondarySale_endStock_Middleware";

import CustomSelect from "../../components/common/select/Select";

import YOYTable from "../../components/tables/yoyTable";
import QuartersTable from "../../components/tables/quarterTable";
import HalfTable from "../../components/tables/halfTable";
import HalfGrowthTable from "../../components/tables/halfGrowthTable";
import TotalsTable from "../../components/tables/totalsTable";
import TrendLineChart from "../../components/line-charts/LineChart";
import MyBarChart from "../../components/bar-charts/MyBarChart";
import YOYBarChart from "../../components/bar-charts/YOYBarCharts";
import QuarterAnalysisBarChart from "../../components/bar-charts/QtrAnBarChart";
import MyPieChart from "../../components/pie-charts/pieChart";
import SeasonCoutTable from "../../components/tables/seasonCountTable";
import GrowthTable from "../../components/tables/growthTable";
import HalfCountTable from "../../components/tables/halfCountTable";
import GrowthTotalTable from "../../components/tables/growthTotalTable";
import GeoChannel from "./GeoChannal";

// import SelectPanel from "./SelectPanel";
// import "../../assets/style/sfos.styles.scss";
import "./SecondaryDashboard.style.scss";
import {compare} from '../../prat_screen/gt/validation/sort';
import CustomToast from '../../util-functions/customToast.jsx'

let selectedBrandFinal = [];
const COLORS = [
  "#69be5e",
  "#fe9f4c",
  "#b27aa1",
  "#4b9795",
  "#e3575a",
  "#a3c8eb",
  "#ebd165",
];

const COLORS_ = [
  "#d1ebce",
  "#ffe2c9",
  "#e8d7e3",
  "#c8e0df",
  "#f7cccd",
  "#d2d9e0",
  "#f9f1d0",
];

class SecondaryDashboard extends Component {
  constructor() {
    super();
    this.state = {
      myTempSkus: [],
      myTempBrands: [],
      myBrands: [],
      mySkus: [],
      selectedValue: "",
      isLoading: false,
      category: null,
      selectedCategory: [],
      selectedBrand: [],
      selectedSku: [],
      selectedRegion: [],
      isValue: false,
      selectedDemandDriver: [],
      isLoadingInitial: true,
      selectChannel: [],
      volumeOptions: [
        {
          label: "VOLUME",
          value: false,
        },
        {
          label: "VALUE",
          value: true,
        },
      ],
      value: "",
    };
  }

  componentDidMount() {
    if (!navigator.onLine) {
      CustomToast('error', "You are Offline")
      return;
    }
    setTimeout(() => {
      this.props.getCategory();
      this.props.getBrands();
      this.props.getSkus();
      this.props.getRegions();
      this.props.getChannel();
      // if (this.props.secondaryDashboard == undefined) {
      // setTimeout(() => {
      //   this.getDataOnComponentMount();
      // }, 2000);
    }, 1000);
    // }
  }

  componentDidUpdate(prevProps, prevState){
    
    if (prevProps.category !== this.props.category) {
      this.getDataOnComponentMount();
    }

    if(prevProps.brands !== this.props.brands){
      this.getBrands();
    }
  }

  /**
   * new data
   */
  handleFilteredBrands = () => {
    const {
      selectedCategory,
      myBrands,
      selectedBrand,
      mySkus,
      selectedSku,
    } = this.state;
    const { brands } = this.props;
    let filteredbrands = [];
    if (selectedCategory.length) {
      for (let i = 0; i < selectedCategory.length; i++) {
        filteredbrands.push(
          ...brands.filter((item) => {
            return item.Category === selectedCategory[i];
          })
        );
      }
      selectedBrandFinal = [];
      myBrands.forEach((element) => {
        if (selectedBrand.length !== 0) {
          selectedBrand.forEach((e) => {
            if (element.guid === e) {
              selectedBrandFinal.push(e);
              this.setState({
                selectedBrand: selectedBrandFinal,
                newSelectedBrand: selectedBrandFinal,
              });
              // Fot sku Filteration
              if (selectedSku.length !== 0) {
                mySkus.forEach((skuElement, i) => {
                  selectedBrandFinal.forEach((se) => {
                    if (skuElement.Brand === se) {
                      selectedSku.forEach((el) => {
                        if (skuElement.guid === el) {
                          this.setState({
                            selectedSku: [],
                          });
                        }
                      });
                    }
                  });
                });
              }
            }
          });
        }
      });
      this.setState({
        myBrands: filteredbrands,
      });
    }
  };

  handleFilteredSkus = () => {
    const { selectedBrand, selectedSku, mySkus } = this.state;
    // console.log("SEL BRAND", selectedBrand);
    const { skus } = this.props;
    // console.log("SEL BRAND", skus.Brand);
    let filteredSkus = [];
    if (selectedBrand.length) {
      // alert("hekko");
      for (let i = 0; i < selectedBrand.length; i++) {
        filteredSkus.push(
          ...skus.filter((item) => {
            return item.Brand === selectedBrand[i];
          })
        );
      }

      let selectedSkuFinal = [];
      mySkus.forEach((element) => {
        if (selectedSku.length !== 0) {
          selectedSku.forEach((e) => {
            if (element.guid === e) {
              selectedSkuFinal.push(e);
              // localStorage.setItem('brands', selectedBrandFinal)
              this.setState({
                selectedSku: selectedSkuFinal,
              });
              // console.log(selectedSkuFinal)
            }
          });
        }
      });

      this.setState({
        mySkus: filteredSkus,
      });
    }
  };

  handleChange = (selectedValue) => {
    // console.log(`%c VALUE  ${selectedValue}`, 'color:dodgerblue'  );
    let arr = [];
    if (selectedValue === null || selectedValue.length === 0) {
      // alert("hello");
      this.setState({
        selectedCategory: [],
        myBrands: [],
        selectedBrand: [],
        selectedSku: [],
        mySkus: [],
      });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });

      this.setState({ selectedCategory: arr }, () => {
        // this.handleFilteredBrands();
        this.getBrands();
      });
    }
  };

  handleBrandChange = (selectedValue) => {
    // console.log("VALUE", selectedValue);
    let arr = [];
    if (selectedValue === null || selectedValue.length === 0) {
      this.setState({ selectedBrand: [], selectedSku: [], mySkus: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      // console.log("ARR", arr);
      this.setState({ selectedBrand: arr }, () => {
        this.handleFilteredSkus();
      });
    }
  };

  handleSkus = (selectedValue) => {
    // console.log("SKUS", selectedValue);
    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectedSku: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      // console.log("SKUS", arr);
      this.setState({ selectedSku: arr });
    }
  };

  handleRegion = (selectedValue) => {
    // console.log("VALUE", selectedValue);
    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectedRegion: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      // console.log("REGION", arr);
      this.setState({ selectedRegion: arr });
    }
  };

  handleIsValue = (selectedValue) => {
    if (selectedValue) {
      // console.log("Isvalue", selectedValue.value);
      this.setState({
        isValue: selectedValue.value,
      });
    }
  };

  handleChannel = (selectedValue) => {
    // console.log("Demand Driver", selectedValue);

    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectChannel: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      // console.log("REGION", arr);
      this.setState({ selectChannel: arr });
    }
  };

  getDataOnComponentMount = () => {
      this.setState(
        {
          page: 1,
          selectedCategory: [this.props.category[0].guid],
          selectedBrand: [],
          selectedSku: [],
          selectedRegion: [],
          isValue: false,
        },
        () => {
          if(this.props?.brands){
            this.getBrands();
          }
            this.props.postSecondaryDashboard(
              this.state.selectedCategory,
              this.state.selectedBrand,
              this.state.selectedSku,
              this.state.selectedRegion,
              this.state.selectChannel,
              this.state.isValue
            );
            this.props.getChannelSale(
              this.state.selectedCategory,
              this.state.selectedBrand,
              this.state.selectedSku,
              this.state.selectedRegion,
              this.state.selectChannel,
              this.state.isValue
            );
            this.props.getRegionsGrowth(
              this.state.selectedCategory,
              this.state.selectedBrand,
              this.state.selectedSku,
              this.state.selectedRegion,
              this.state.selectChannel,
              this.state.isValue
            );
            // this.props.getSecondarySaleEndStock(
            //   this.state.selectedCategory,
            //   this.state.selectedBrand,
            //   this.state.selectedSku,
            //   this.state.selectedRegion,
            //   this.state.selectChannel,
            //   this.state.isValue
            // );
            this.props.getEndStock(
              this.state.selectedCategory,
              this.state.selectedBrand,
              this.state.selectedSku,
              this.state.selectedRegion,
              this.state.selectChannel,
              this.state.isValue
            );
            this.props.getSecondarySale(
              this.state.selectedCategory,
              this.state.selectedBrand,
              this.state.selectedSku,
              this.state.selectedRegion,
              this.state.selectChannel,
              this.state.isValue
            );
          this.setState({ isLoadingInitial: false });
        }
      );
  };

  getBrands = () => {
    // setTimeout(() => {
      const {
        selectedCategory,
        // myBrands,
        // selectedBrand,
        // mySkus,
        // selectedSku,
      } = this.state;
      const { brands } = this.props;
      let filteredbrands = [];
      if (selectedCategory.length) {
        // alert('hello')
        for (let i = 0; i < selectedCategory.length; i++) {
          filteredbrands.push(
            ...brands.filter((item) => {
              return item.Category === selectedCategory[i];
            })
          );
        }
      }
      this.setState({
        myBrands: filteredbrands,
      },
      () => {
        let selectBrands = [];
        this.state.myBrands.length &&
          this.state.myBrands.forEach(item => selectBrands.push(item.guid));
        this.setState({
          selectedBrand: selectBrands
        });
      });
      this.getSkus();
    // }, 5000);
  };

  getSkus = () => {
    setTimeout(() => {
      const { selectedBrand } = this.state;
      // console.log("SEL BRAND", selectedBrand);
      const { skus } = this.props;
      // console.log("SEL BRAND", skus.Brand);
      let filteredSkus = [];
      if (selectedBrand.length) {
        // alert("hekko");
        for (let i = 0; i < selectedBrand.length; i++) {
          filteredSkus.push(
            ...skus.filter((item) => {
              return item.Brand === selectedBrand[i];
            })
          );
        }
      }
      this.setState({
        mySkus: filteredSkus,
      });
    }, 1000);
  };

  handleDataFirstTime = () => {
    const {
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue,
    } = this.state;
    setTimeout(() => {
      this.props.postSecondaryDashboard(
        selectedCategory,
        selectedBrand,
        selectedSku,
        selectedRegion,
        selectChannel,
        isValue
      );
    }, 1000);
  };

  handleSubmit = (e) => {
    const {
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      isValue,
      selectChannel,
    } = this.state;
    this.props.postSecondaryDashboard(
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    );
    this.props.getChannelSale(
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    );
    this.props.getRegionsGrowth(
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    );
    // this.props.getSecondarySaleEndStock(
    //   selectedCategory,
    //   selectedBrand,
    //   selectedSku,
    //   selectedRegion,
    //   selectChannel,
    //   isValue
    // );
    this.props.getEndStock(
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    );
    this.props.getSecondarySale(
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    );
  };

  handleDownload = (e) => {
    e.preventDefault();
    // console.log("DEMAND", selectedDemandDriver);
    // console.log("DEMAND", selectedDemandDriver);

    // if (
    //   this.state.selectedDemandDriver !== null &&
    //   this.state.selectedCategory !== null
    // ) {
    //   if (
    //     Array.isArray(this.state.selectedDemandDriver) &&
    //     this.state.selectedDemandDriver.length &&
    //     Array.isArray(this.state.selectedCategory) &&
    //     this.state.selectedCategory.length
    //   ) {
    //     // console.log("IS ARRAY", selectedDemandDriver);
    this.props.downloadXlx(this.props.secondaryDashboard);
    //     this.setState({ primaryDashboard: this.props.primaryDashboard });
    //   } else {
    //     // alert('hello')
    //     ToastsStore.error("Demand Driver or Category is not selected!");
    //   }
    // } else {
    //   ToastsStore.error("Demand Driver or Category is not selected!");
    // }
  };

  render() {
    const {
      category,
      secondaryDashboard,
      regionsGrowthData,
      channel,
      channelSaleData,
      isLoading,
      regions
    } = this.props;
    if (!category) {
      return <Loader flag={isLoading} />;
    } else {
      return this.props.isSecondaryDashboardLoading ? (
        <Loader flag={this.props.isSecondaryDashboardLoading} />
      ) : secondaryDashboard === undefined ? (
        <Loader flag={this.state.isLoadingInitial} />
      ) : (
        <div className="page-container">
          {/* <SelectPanel
            handleSbmitFN={this.handleSbmitFN}
            screen={"secondary-dashboard"}
          /> */}
          <div className="heading-and-download-container">
            <span className="component-heading">Secondary Dashboard</span>

            {this.props.isFileDownloading ? (
              <img
                src={Downloading}
                style={{ width: "26px", height: "31px" }}
                alt=''
              />
            ) : (
              <img
                src={DownloadIcon}
                onClick={this.handleDownload}
                className="download-xlx-img"
                alt="xldownload"
              />
            )}
          </div>
          {/* <div className="select-and-download-container"> */}
          <div className="select-container">
            <div className="filters-container-only">
              {/* {isCategoryLoading ? (
                "Loading..."
              ) : ( */}
              <CustomSelect.MyCustomSelect
                placeholder={"Category"}
                allowSelectAll={true}
                isMulti
                options={
                  category
                    ? category.sort(compare).map((item) => {
                        return {
                          value: item.guid,
                          label: item.Name,
                        };
                      })
                    : []
                }
                onChange={this.handleChange}
                value={category
                  .filter((item) => {
                    return this.state.selectedCategory.includes(item.guid);
                  })
                  .map((item) => {
                    return {
                      value: item.guid,
                      label: item.Name,
                    };
                  })}
              />
              {/* )} */}
              <CustomSelect.MyCustomSelect
                placeholder={"Brands"}
                allowSelectAll={true}
                isMulti
                options={
                  this.state.myBrands
                    ? this.state.myBrands.sort(compare).map((item) => ({
                        value: item.guid,
                        label: item.Name,
                      }))
                    : []
                }
                // defaultValue={this.state.myBrands[0]}
                onChange={this.handleBrandChange}
                value={this.state.myBrands
                  .filter((item) => {
                    return this.state.selectedBrand.includes(item.guid);
                  })
                  .map((item) => {
                    return {
                      value: item.guid,
                      label: item.Name,
                    };
                  })}
              />
              <CustomSelect.MyCustomSelect
                placeholder={"MSKUs"}
                allowSelectAll={true}
                isMulti
                options={
                  this.state.mySkus
                    ? this.state.mySkus.sort(compare).map((item) => ({
                        value: item.guid,
                        label: item.Description,
                      }))
                    : []
                }
                onChange={this.handleSkus}
                value={this.state.mySkus
                  .filter((item) => {
                    return this.state.selectedSku.includes(item.guid);
                  })
                  .map((item) => {
                    return {
                      value: item.guid,
                      label: item.Description,
                    };
                  })}
              />
              <CustomSelect.MyCustomSelect
                placeholder={"Region"}
                allowSelectAll={true}
                isMulti
                options={
                  regions
                    ? regions.sort(compare).map((item) => ({
                        value: item.guid,
                        label: item.Name.toUpperCase(),
                      }))
                    : []
                }
                onChange={this.handleRegion}
                value={
                  regions
                    ? regions
                        .filter((item) => {
                          return this.state.selectedRegion.includes(item.guid);
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Name.toUpperCase(),
                          };
                        })
                    : null
                }
              />
              <CustomSelect.MySelect
                options={this.state.volumeOptions}
                onChange={this.handleIsValue}
                defaultValue={
                  this.state.isValue
                    ? this.state.volumeOptions[1]
                    : this.state.volumeOptions[0]
                }
              />
              <CustomSelect.MyCustomSelect
                placeholder={"Channel"}
                allowSelectAll={true}
                isMulti
                options={
                  channel
                    ? channel.map((item) => ({
                        value: item.guid,
                        label: item.Name,
                      }))
                    : []
                }
                onChange={this.handleChannel}
                // value={this.state.selectedDemandDriver}
                value={
                  channel
                    ? channel
                        .filter((item) => {
                          return this.state.selectChannel.includes(item.guid);
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Name,
                          };
                        })
                    : null
                }
              />
            </div>

            <Button
              variant="outlined"
              className="submit-btn"
              onClick={(e) => this.handleSubmit(e)}
            >
              SUBMIT
            </Button>
            {/* </div> */}
            {/* {this.props.isFileDownloading ? (
              <img
                src={Downloading}
                style={{ width: "40px", height: "50px" }}
              />
            ) : (
              <img
                src={DownloadIcon}
                onClick={this.handleDownload}
                className="download-xlx-img"
                alt="xldownload"
              />
            )} */}
          </div>
          {/* </div> */}

          <div className="main-table-container">
            <span className="table-container-heading">YOY - Volume</span>
            <div className="four-tables">
              <YOYTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.Volume
                    : []
                }
              />
              <QuartersTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.QuaterVolume
                    : null
                }
              />
              <HalfTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.HalfVolume
                    : null
                }
              />
              <TotalsTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.TotalVolume
                    : null
                }
              />
            </div>
          </div>

          <div className="main-table-container">
            <span className="table-container-heading">YOY - AWS</span>
            <div className="four-tables">
              <YOYTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.Aws
                    : []
                }
              />
              <QuartersTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.QuaterAws
                    : null
                }
              />
              <HalfTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.HalfAws
                    : null
                }
              />
              <TotalsTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.TotalAws
                    : null
                }
              />
            </div>
          </div>

          <div className="main-table-container">
                <span className="table-container-heading">YOY - ADS</span>
                <div className="four-tables">
                  <YOYTable
                    data={
                      this.props.secondaryDashboard
                        ? this.props.secondaryDashboard.Ads
                        : []
                    }
                  />
                  <QuartersTable
                    data={
                      this.props.secondaryDashboard
                        ? this.props.secondaryDashboard.QuaterAds
                        : null
                    }
                  />
                  <HalfTable
                    data={
                      this.props.secondaryDashboard
                        ? this.props.secondaryDashboard.HalfAds
                        : null
                    }
                  />
                  <TotalsTable
                    data={
                      this.props.secondaryDashboard
                        ? this.props.secondaryDashboard.TotalAds
                        : null
                    }
                  />
                </div>
              </div>


          <div className="main-chart-container">
            <div className="chart-div">
              <div className="chart-title-container">
                <span className="chart-title">Trend Line</span>
              </div>
              <TrendLineChart
                data={
                  this.props.secondaryDashboard &&
                  this.props.secondaryDashboard.Volume.length > 0
                    ? this.props.secondaryDashboard.Volume
                    : []
                }
              />
            </div>

            <div className="chart-div">
              <div className="chart-title-container">
                <span className="chart-title">Quarter Analysis</span>
              </div>
              <MyBarChart
                dataKey="QuaterVolume"
                data={
                  this.props.secondaryDashboard &&
                  this.props.secondaryDashboard.QuaterVolume.length > 0
                    ? this.props.secondaryDashboard.QuaterVolume
                    : []
                }
              />
            </div>

            <div className="chart-div">
              <div className="chart-title-container">
                <span className="chart-title">H1 vs H2</span>
              </div>
              <QuarterAnalysisBarChart
                type="SD"
                dataKey="HalfVolume"
                data={
                  this.props.secondaryDashboard?.HalfVolume.length > 0
                    ? this.props.secondaryDashboard.HalfVolume
                    : []
                }
              />
            </div>
          </div>

          <div className="main-chart-table-container">
            <div className="chart-table-div-1">
              <div className="chart-title-container">
                <span className="chart-title">YOY</span>
              </div>
              <YOYBarChart
                data={
                  this.props.secondaryDashboard?.TotalVolume.length > 0
                    ? this.props.secondaryDashboard.TotalVolume
                    : []
                }
              />
            </div>

            <div className="chart-table-div-1">
              <div className="chart-title-container">
                <span className="chart-title">Geo Channel</span>
              </div>
              <GeoChannel
                data={
                  channelSaleData && channelSaleData.length > 0
                    ? channelSaleData
                    : []
                }
              />
            </div>

            <div className="chart-table-div-2">
              <div className="chart-title-container">
                <span className="chart-title">H1 vs H2 Growth</span>
              </div>
              <HalfGrowthTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.GrowthHalf
                    : null
                }
              />
            </div>

            <div className="chart-table-div-3">
              <div className="widget-container" style={{ marginBottom: "8px" }}>
                <span className="widget-heading">VG for Year 2020</span>
                <span className="widget-value">
                  {this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.VG
                    : "--"}
                  %
                </span>
              </div>
              <div className="widget-container">
                <span className="widget-heading">CAGR 5 Years</span>
                <span className="widget-value">
                  {this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.CAGR
                    : "--"}
                  %
                </span>
              </div>
            </div>
          </div>

          <div
            className="main-chart-table-container"
            style={{ height: "240px" }}
          >
            <div
              className="chart-div"
              style={{ width: "100%", backgroundColor: "white" }}
            >
              <div className="chart-title-container">
                <span className="chart-title">Regional (Growth %) YTD</span>
              </div>
              <div
                className="chart-div"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                {regionsGrowthData && regionsGrowthData.length > 0
                  ? regionsGrowthData.map((itm, ind) => {
                      return (
                        <div className="sub-piechart-container">
                          <span className="percentage-value">
                            {itm.Growth.toFixed(0) + "%"}
                          </span>
                          <MyPieChart
                            type="SD"
                            data={itm}
                            ind={ind}
                            colorFill={COLORS[ind]}
                            colorVoid={COLORS_[ind]}
                          />
                          <span className="pie-heading">{itm.RegionName}</span>
                        </div>
                      );
                    })
                  : []}
              </div>
            </div>
          </div>

          <div
            className="main-chart-table-container"
            style={{ height: "520px" }}
          >
            <div
              className="chart-div"
              style={{ width: "100%", backgroundColor: "white" }}
            >
              <div className="chart-title-container">
                <span className="chart-title">
                  Secondary Sale and End Stock
                </span>
              </div>
              {/* {this.props.EndStock==undefined  && <img src={require('../../assets/images/barsLoader.svg')} className='loaderImage'/>} */}
              {this.props.SecondarySale !== undefined && (
                <SecondarySalesEndStockChar
                  data={
                    this.props.secondarySale_endStock !== undefined &&
                    this.props.secondarySale_endStock.length > 0 &&
                    this.props.secondarySale_endStock
                  }
                  endStock={
                    this.props.EndStock !== undefined &&
                    this.props.EndStock.length > 0 &&
                    this.props.EndStock
                  }
                  secondarySale={
                    this.props.SecondarySale !== undefined &&
                    this.props.SecondarySale.length > 0 &&
                    this.props.SecondarySale
                  }
                />
              )}
            </div>
          </div>

          {/* <div className="bar_line-SS-ES-container">
              <div className="SS-ES-title-container">
                <div className="chart-title-container">
                  <span className="chart-title">
                    Secondary Sale and End Stock
                  </span>
                </div>
                <div className="SS-ES-combine-graph-container">
                  <SecondarySales_EndStockChar
                    data={
                      this.props.secondarySale_endStock !== undefined &&
                      this.props.secondarySale_endStock.length > 0 &&
                      this.props.secondarySale_endStock
                    }
                  />
                </div>
              </div>
            </div> */}

          <div className="last-table-row">
            <div className="seasonality-table-container">
              <div className="chart-title-container">
                <span className="chart-title">Seasonality</span>
              </div>

              <SeasonCoutTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.Seasonality
                    : null
                }
              />
            </div>

            <div className="seasonality-table-container">
              <div className="chart-title-container">
                <span className="chart-title">Contribution</span>
              </div>

              <SeasonCoutTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.Contribution
                    : null
                }
              />
            </div>

            <div className="seasonality-table-container">
              <div className="chart-title-container">
                <span className="chart-title">Quarterly Growth</span>
              </div>

              <GrowthTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.GrowthQuater
                    : null
                }
              />
            </div>

            <div className="half-cont-table-container">
              <div className="chart-title-container">
                <span className="chart-title">Half-Yr Contribution</span>
              </div>

              <HalfCountTable
                data={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.HalfContribution
                    : null
                }
              />
            </div>

            <div className="total-growth-table-container">
              <div className="chart-title-container">
                <span className="chart-title">Growth</span>
              </div>
              <div className="pie-PD-container">
                <GrowthTotalTable
                  data={
                    this.props.secondaryDashboard
                      ? this.props.secondaryDashboard.GrowthTotal
                      : null
                  }
                />
              </div>
            </div>
          </div>

          {/* <div className="tabels-charts-container"> */}

          {/* {this.props.isSecondaryDashboardLoading ? (
              "Loading..."
            ) : (
              <>
                <YOYTable
                  volume={
                    this.props.secondaryDashboard
                      ? this.props.secondaryDashboard.Volume
                      : null
                  }
                />
                <div className="four-tables-container">
                  <QuartersTable
                    quarterVolume={
                      this.props.secondaryDashboard
                        ? this.props.secondaryDashboard.QuaterVolume
                        : null
                    }
                  />
                  <HalfTable
                    halfVolume={
                      this.props.secondaryDashboard
                        ? this.props.secondaryDashboard.HalfVolume
                        : null
                    }
                  />
                  <TotalsTable
                    totalVolume={
                      this.props.secondaryDashboard
                        ? this.props.secondaryDashboard.TotalVolume
                        : null
                    }
                  />
                  <div className="vg-for-year">
                    <div className="vg-title">
                      <h3>VG for Year 2020</h3>
                    </div>
                    <div>
                      <span className="vg-value">
                        {this.props.secondaryDashboard?.VG}%
                      </span>
                    </div>
                  </div>
                </div>

                <YOYTable
                  volumeAws={
                    this.props.secondaryDashboard
                      ? this.props.secondaryDashboard.Aws
                      : null
                  }
                />
                <div className="four-tables-container">
                  <QuartersTable
                    quarterAws={
                      this.props.secondaryDashboard
                        ? this.props.secondaryDashboard.QuaterAws
                        : null
                    }
                  />
                  <HalfTable
                    halfVolume={
                      this.props.secondaryDashboard
                        ? this.props.secondaryDashboard.HalfAws
                        : null
                    }
                  />
                  <TotalsTable
                    totalVolume={
                      this.props.secondaryDashboard
                        ? this.props.secondaryDashboard.TotalAws
                        : null
                    }
                  />
                  <div className="vg-for-year">
                    <div className="vg-title">
                      <h3>CAGR 5 Years</h3>
                    </div>
                    <div>
                      <span className="vg-value">
                        {this.props.secondaryDashboard?.CAGR}%
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="after-table-charts">
              <div className="chart-div right-margin">
                <div className="chart-title-container">
                  <span className="chart-title">Trend Line</span>
                </div>
                <TrendLineChart
                  data={
                    this.props.secondaryDashboard?.Volume.length > 0
                      ? this.props.secondaryDashboard.Volume
                      : []
                  }
                />
              </div>
              <div className="chart-div">
                <div className="chart-title-container">
                  <span className="chart-title">Quarter Analysis</span>
                </div>
                <MyBarChart
                  dataKey="QuaterVolume"
                  data={
                    this.props.secondaryDashboard?.QuaterVolume.length > 0
                      ? this.props.secondaryDashboard.QuaterVolume
                      : []
                  }
                />
              </div>
            </div>

            <div className="after-table-charts">
              <div className="chart-div right-margin">
                <div className="chart-title-container">
                  <span className="chart-title">H1 vs H2</span>
                </div>
                <MyBarChart
                  dataKey="HalfVolume"
                  data={
                    this.props.secondaryDashboard?.HalfVolume.length > 0
                      ? this.props.secondaryDashboard.HalfVolume
                      : []
                  }
                />
              </div>
              <div className="chart-div">
                <div className="chart-title-container">
                  <span className="chart-title">YOY</span>
                </div>
                <YOYBarChart
                  data={
                    this.props.secondaryDashboard?.TotalVolume.length > 0
                      ? this.props.secondaryDashboard.TotalVolume
                      : []
                  }
                />
              </div>
            </div>


            <div className="geo-channel-chart">
              <div className="chart-title-container">
                <span className="chart-title">Geo Channel</span>
              </div>
              <GeoChannel
                data={
                  channelSaleData && channelSaleData.length > 0
                    ? channelSaleData
                    : []
                }
              />
            </div>
            <div className="piechart-demandquater-container">
              <div className="vol-growth-container">
                <div className="chart-title-container">
                  <span className="chart-title">Regional (Growth %) YTD</span>
                </div>
                <div className="vertical-and-pie-container">
                  <div className="sd-reginal-piecharts-container">
                    {regionsGrowthData && regionsGrowthData.length > 0
                      ? regionsGrowthData.map((itm, ind) => {
                          return (
                            <div>
                              <div className="sub-piechart-container">
                                <SDPieChart data={itm} ind={ind} />
                                <span className="pie-value">
                                  {itm.Growth.toFixed(0)}%
                                </span>
                              </div>
                              <span className="pie-title">
                                {itm.RegionName}
                              </span>
                            </div>
                          );
                        })
                      : []}
                  </div>
                </div>
              </div>
            </div>
            <div className="bar_line-SS-ES-container">
              <div className="SS-ES-title-container">
                <div className="chart-title-container">
                  <span className="chart-title">
                    Secondary Sale and End Stock
                  </span>
                </div>
                <div className="SS-ES-combine-graph-container">
                  <SecondarySales_EndStockChar
                    data={
                      this.props.secondarySale_endStock !== undefined &&
                      this.props.secondarySale_endStock.length > 0 &&
                      this.props.secondarySale_endStock
                    }
                  />
                </div>
              </div>
            </div>
            <div className="seasonaliy-count-tabels">
              <SeasonCoutTable
                seasonality={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.Seasonality
                    : null
                }
              />
              <SeasonCoutTable
                contribution={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.Contribution
                    : null
                }
              />
            </div>
            <div className="seasonaliy-count-tabels">
              <GrowthTable
                growthQuater={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.GrowthQuater
                    : null
                }
              />
              <HalfCountTable
                halfContribution={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.HalfContribution
                    : null
                }
              />
              <GrowthTotalTable
                growthTotal={
                  this.props.secondaryDashboard
                    ? this.props.secondaryDashboard.GrowthTotal
                    : null
                }
              />
            </div>
          */}
          {/* </div> */}
        </div>
      );
    }
  }
}
const mapStateToProps = (state) => {
  return {
    isLoading: state.CategoryReducer.isLoading,
    category: state.CategoryReducer.category,
    isCategoryLoading: state.CategoryReducer.isCategoryLoading,
    brands: state.BrandsReducer.brands,
    skus: state.SkusReducer.skus,
    regions: state.RegionReducer.regions,
    channel: state.ChannelReducer.channel,
    secondaryDashboard: state.SecondaryDashboardReducer.secondaryDashboard,
    isSecondaryDashboardLoading:
      state.SecondaryDashboardReducer.isSecondaryDashboardLoading,
    regionsGrowthData: state.regionsGrowthReducer.regionGrowth,
    channelSaleData: state.ChannelSaleReducer.channelSale,
    isFileDownloading: state.DownloadXlxReducer.isFileDownloading,
    secondarySale_endStock: state.SecondarySaleEndSctock.secondarySaleEndStock,
    EndStock: state.SecondarySaleEndSctock.EndStock,
    SecondarySale: state.SecondarySaleEndSctock.SecondarySale,
    isSecondarySaleEndStockLoading:
      state.SecondarySaleEndSctock.is_SS_ED_Loading,
  };
};

const mapDispatchToprops = (dispatch) => {
  return {
    getCategory: () => {
      return dispatch(CategoryMiddleware.getCategory());
    },
    getBrands: () => {
      return dispatch(BrandsMiddleware.getBrands());
    },
    getSkus: () => {
      return dispatch(SkusMiddleware.getSkus());
    },
    getRegions: () => {
      return dispatch(RegionsMiddleware.getRegions());
    },
    getChannel: () => {
      return dispatch(ChannelMiddleware.getChannel());
    },
    getChannelSale: (
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    ) => {
      return dispatch(
        ChannelSaleMiddleware.getChannelSale(
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectChannel,
          isValue
        )
      );
    },
    getRegionsGrowth: (
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    ) => {
      return dispatch(
        RegionsGrowthMiddleWare.getRegionsGrowth(
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectChannel,
          isValue
        )
      );
    },
    postSecondaryDashboard: (
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    ) => {
      return dispatch(
        SecondaryDashboardMiddleware.postSecondaryDashboard(
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectChannel,
          isValue
        )
      );
    },
    getSecondarySaleEndStock: (
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    ) => {
      return dispatch(
        SecondarySale_EndStock_Middleware.getSecondarySaleEndStock(
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectChannel,
          isValue
        )
      );
    },
    getEndStock: (
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    ) => {
      return dispatch(
        SecondarySale_EndStock_Middleware.getEndStock(
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectChannel,
          isValue
        )
      );
    },
    getSecondarySale: (
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectChannel,
      isValue
    ) => {
      return dispatch(
        SecondarySale_EndStock_Middleware.getSecondarySale(
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectChannel,
          isValue
        )
      );
    },

    downloadXlx: (secondaryDashboard) => {
      return dispatch(
        DownloadSecondaryXlxMiddleware.downloadXlx(secondaryDashboard)
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(SecondaryDashboard);
